"use client";
import { useEffect, useState } from "react";

export function ActionLogRoller({ logs }: { logs: string[] }) {
  const visible = logs.slice(0, 3);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((v) => v + 1), 1000);
    return () => clearInterval(t);
  }, []);

  if (visible.length === 0) {
    return (
      <div style={{ borderRadius: 8, border: '1px dashed rgba(255,255,255,0.2)', padding: '8px 12px', fontSize: 12, color: '#94a3b8' }}>
        에이전트 대기 중{".".repeat(tick % 4)}
      </div>
    );
  }

  return (
    <ul style={{ display: 'flex', flexDirection: 'column', gap: 4, borderRadius: 8, border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(0,0,0,0.2)', padding: '8px 12px', listStyle: 'none', margin: 0 }}>
      {visible.map((m, i) => (
        <li
          key={`${m}-${i}`}
          style={{
            fontSize: 12,
            color: i === 0 ? '#f8fafc' : '#64748b',
            fontWeight: i === 0 ? 500 : 400
          }}
        >
          {i === 0 ? "▸ " : "  "}
          {m}
        </li>
      ))}
    </ul>
  );
}
